<template>
  <form id="charter-form" class="" @submit.prevent="processForm">
    <div class="flex items-center justify-center py-16 bg-dark-type-1">
      <div
        class="
          px-4
          py-6
          text-white
          border
          rounded-md
          lg:max-w-sm-5
          bg-secondary
          border-dark-type-2
        "
      >
        <div class="p-4 mb-4 rounded-md bg-red-type-1" v-if="errorMessage">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg
                class="w-5 h-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-bold text-white">An error occurred!</h3>
              <div class="mt-2 text-sm font-medium text-white">
                <p>
                  {{ errorMessage }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <h1 class="pr-16 text-2xl font-bold">Charter a shuttle</h1>
        <p class="text-sm font-medium">
          Tell us when and where and we'll make it happen
        </p>
        <div class="mt-6">
          <label for="first-name" class="sr-only">First Name</label>
          <input
            v-model="$v.formData.fname.$model"
            type="text"
            class="w-full input--neutral input_style user_inputs"
            required
            id="first-name"
            placeholder="Enter your first name"
          />
          <span
            class="text-xs font-bold text-red-400"
            v-if="!$v.formData.fname.required && $v.formData.fname.$error"
            >Please enter your first name</span
          >
        </div>
        <div class="mt-4">
          <label for="last-name" class="sr-only">Last Name</label>
          <input
            v-model="$v.formData.lname.$model"
            type="text"
            class="w-full input--neutral input_style user_inputs"
            id="last-name"
            required
            placeholder="Enter your last name"
          />
          <span
            class="text-xs font-bold text-red-400"
            v-if="!$v.formData.lname.required && $v.formData.lname.$error"
            >Please enter your last name</span
          >
        </div>
        <div class="mt-4">
          <label for="email" class="sr-only">Email Name</label>
          <input
            v-model="$v.formData.email.$model"
            type="email"
            class="w-full input--neutral input_style user_inputs"
            required
            id="email"
            placeholder="Enter your email"
          />
          <span
            class="text-xs font-bold text-red-400"
            v-if="!$v.formData.email.required && $v.formData.email.$error"
            >Please enter your email address</span
          >
        </div>
        <div class="mt-4">
          <label for="phone" class="sr-only">Phone Number</label>
          <input
            v-model="$v.formData.phone.$model"
            type="number"
            class="w-full input--neutral input_style user_inputs"
            minlength="11"
            required
            id="phone"
            placeholder="Enter your phone number"
          />
          <span
            class="text-xs font-bold text-red-400"
            v-if="!$v.formData.phone.required && $v.formData.phone.$error"
            >Please enter your phone number</span
          >
          <span
            class="text-xs font-bold text-red-400"
            v-else-if="!$v.formData.phone.minlength && $v.formData.phone.$error"
            >Phone number must be at least 9 digits</span
          >
        </div>
        <div class="relative w-full mt-6">
          <div class="">
            <route-location-selector
              :value="formData.pick_up"
              :bus-stops="mapRoutesForSelect"
              label="from"
              placeholder="Departure Location"
              @location-selected="(location) => (formData.pick_up = location)"
              find-by-location-enabled
            ></route-location-selector>
            <span
              class="text-xs font-bold text-red-400"
              v-if="!$v.formData.pick_up.required && $v.formData.pick_up.$error"
              >Please choose a departure location</span
            >
          </div>
          <div class="mt-2">
            <route-location-selector
              :value="formData.destination"
              :bus-stops="destinationBusStops"
              label="to"
              placeholder="Arrival Location"
              @location-selected="
                (location) => (formData.destination = location)
              "
              find-by-location-enabled
            ></route-location-selector>
            <span
              class="text-xs font-bold text-red-400"
              v-if="
                !$v.formData.destination.required &&
                $v.formData.destination.$error
              "
              >Please choose an arrival location</span
            >
          </div>
        </div>
        <div class="flex items-center pr-4 mt-4">
          <div class="w-1/2">
            <div class="font-bold text-center">Pick up time</div>
          </div>
          <div class="w-1/2">
            <div class="font-bold text-center">Return time</div>
          </div>
        </div>
        <div class="flex items-center mt-4 space-x-4">
          <div class="w-1/2">
            <div class="relative inline-block w-full input--neutral">
              <flat-pickr
                v-model="formData.pickUpDate"
                placeholder="Choose date"
                :config="{ minDate: 'today' }"
                class="
                  block
                  w-full
                  h-full
                  px-4
                  py-2
                  pr-8
                  text-sm
                  font-medium
                  leading-tight
                  rounded
                  appearance-none
                  input--neutral
                  focus:outline-none
                "
              ></flat-pickr>
              <div
                class="
                  absolute
                  inset-y-0
                  right-0
                  flex
                  items-center
                  px-2
                  pointer-events-none
                "
              >
                <svg
                  class="w-6 h-6 fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
            <div class="flex items-center mt-4 space-x-2">
              <select
                v-model="formData.pickUpHour"
                class="w-full text-sm text-center input--neutral"
              >
                <option value="" disabled selected>00</option>
                <option
                  v-for="(option, index) in time_data.hour"
                  v-bind:key="index"
                >
                  {{ option.value }}
                </option>
              </select>
              <select
                v-model="formData.pickUpMinute"
                class="w-full text-sm text-center input--neutral"
              >
                <option
                  v-for="(option, index) in time_data.minute"
                  v-bind:key="index"
                >
                  {{ option.value }}
                </option>
              </select>
              <select
                v-model="formData.pickUpPeriod"
                class="w-full text-sm text-center input--neutral"
              >
                <option value="" selected>--</option>
                <option>PM</option>
                <option>AM</option>
              </select>
            </div>
          </div>
          <div class="w-1/2">
            <div class="relative inline-block w-full input--neutral">
              <flat-pickr
                v-model="formData.return_date"
                placeholder="Choose date"
                :config="{ minDate: formData.pickUpDate }"
                class="
                  block
                  w-full
                  h-full
                  px-4
                  py-2
                  pr-8
                  text-sm
                  font-medium
                  leading-tight
                  rounded
                  appearance-none
                  input--neutral
                  focus:outline-none
                "
              >
              </flat-pickr>
              <div
                class="
                  absolute
                  inset-y-0
                  right-0
                  flex
                  items-center
                  px-2
                  pointer-events-none
                "
              >
                <svg
                  class="w-6 h-6 fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
            <div class="flex items-center mt-4 space-x-2">
              <select
                v-model="formData.returnHour"
                class="w-full text-sm text-center input--neutral"
                required
              >
                <option value="" disabled selected>00</option>
                <option
                  v-for="(option, index) in time_data.hour"
                  v-bind:key="index"
                >
                  {{ option.value }}
                </option>
              </select>
              <select
                v-model="formData.returnMinute"
                class="w-full text-sm text-center input--neutral"
                required
              >
                <option
                  v-for="(option, index) in time_data.minute"
                  v-bind:key="index"
                >
                  {{ option.value }}
                </option>
              </select>
              <select
                v-model="formData.returnPeriod"
                class="w-full text-sm text-center input--neutral"
              >
                <option value="" selected>--</option>
                <option>PM</option>
                <option>AM</option>
              </select>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <div
            class="relative inline-block w-full pb-2 input--neutral"
            style="height: 56px"
          >
            <input
              v-model="formData.passengers"
              type="number"
              class="w-full input--neutral input_style"
              min="1"
              required
              placeholder="How many passengers are you booking for?"
            />
            <div
              class="absolute bottom-0 mb-1 ml-2 font-medium text-label"
              style="font-size: 10px"
            >
              Boarding passengers
            </div>
          </div>
        </div>
        <div class="mt-4">
          <div
            class="relative inline-block w-full pb-2 input--neutral"
            style="height: 56px"
          >
            <input
              v-model="numberOfStops"
              type="number"
              class="w-full input--neutral input_style"
              min="0"
              placeholder="How many stops in between your trip?"
            />
            <div
              class="absolute bottom-0 mb-1 ml-2 font-medium text-label"
              style="font-size: 10px"
            >
              Number of stops
            </div>
          </div>
        </div>

        <div
          class="mt-4"
          v-show="stops"
          v-for="(stop, index) in stops"
          :key="index"
        >
          <label :for="`stop-${index}`" class="sr-only"></label>
          <input
            v-model="stop.name"
            type="text"
            class="w-full input--neutral input_style user_inputs"
            :id="`stop-${index}`"
            required
            :placeholder="`Location of ${index + 1}${getPosition(
              index + 1
            )} stop`"
          />
          <!-- <span
            class="text-xs font-bold text-red-400"
            v-if="!$v.stop.required && $v.stop.$error"
            >Please enter your stop
          </span> -->
        </div>
        <button
          type="submit"
          class="
            block
            w-full
            py-3
            mt-20
            font-bold
            text-center text-white
            bg-green-300
            rounded
            bg-active-blue
          "
          :disabled="processing"
        >
          {{ processing ? "Processing your request..." : "Submit Request" }}
        </button>
      </div>
    </div>
  </form>
</template>


<script>
import { mapGetters } from "vuex";
import axios from "@/services/axios";
import flatPickr from "vue-flatpickr-component";
import { required, minLength } from "vuelidate/lib/validators";
import RouteLocationSelector from "@/components/discover-routes/RouteLocationSelector.vue";
export default {
  props: {
    discoveryRequired: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    flatPickr,
    RouteLocationSelector,
  },
  data() {
    return {
      processing: false,
      formData: {
        fname: "",
        lname: "",
        email: "",
        phone: "",
        returnMinute: "00",
        returnHour: "",
        returnPeriod: "",
        pickUpHour: "",
        pickUpMinute: "00",
        pickUpPeriod: "",
        pick_up: null,
        destination: null,
        return_date: null,
        pickUpDate: null,
        passengers: "",
      },
      time_data: {
        hour: [
          { value: "01" },
          { value: "02" },
          { value: "03" },
          { value: "04" },
          { value: "05" },
          { value: "06" },
          { value: "07" },
          { value: "08" },
          { value: "09" },
          { value: "10" },
          { value: "11" },
          { value: "12" },
        ],
        minute: [
          { value: "00" },
          { value: "10" },
          { value: "20" },
          { value: "30" },
          { value: "40" },
          { value: "50" },
        ],
        period: "",
      },
      routeOptions: {
        source_route: null,
        destination_route: null,
        departure_date: "",
        return_date: "",
        route_type: "one-way",
        subscription_route_type: "",
        trip_days: [],
        subscription_duration: "",
      },
      discoveredRoutes: {
        first_trip_routes: [],
        second_trip_routes: [],
      },
      numberOfStops: "",

      stops: [],
      errorMessage: "",
    };
  },
  validations: {
    formData: {
      fname: {
        required,
      },
      lname: {
        required,
      },
      email: {
        required,
      },
      phone: {
        required,
        minLength: minLength(9),
      },
      pick_up: {
        required,
      },
      destination: {
        required,
      },
      // returnMinute: "",
      // returnHour: "",
      // returnPeriod: "",
      // pickUpHour: "",
      // pickUpMinute: "",
      // pickUpPeriod: "",
      // pick_up: null,
      // destination: null,
      // return_date: null,
      // pickUpDate: null,
      // passengers: "",
    },
  },
  created() {
    if (!this.busStops.length) {
      this.$store.dispatch("app/fetchBusStops");
    }
  },
  mounted() {
    if (this.user) {
      this.formData = {
        ...this.formData,
        fname: this.user.fname,
        lname: this.user.lname,
        email: this.user.email,
        phone: this.user.phone,
      };
    }
  },
  computed: {
    ...mapGetters("app", ["busStops"]),
    ...mapGetters("auth", ["user"]),
    mapRoutesForSelect() {
      return this.busStops.map((stop) => ({ ...stop, label: stop.location }));
    },
    destinationBusStops() {
      if (this.formData.pick_up) {
        if (this.mapRoutesForSelect.length > 0) {
          if (
            +this.formData.pick_up.id ===
            this.mapRoutesForSelect[this.mapRoutesForSelect.length - 1].id
          ) {
            return [
              this.mapRoutesForSelect[this.mapRoutesForSelect.length - 1],
            ];
          }
        }

        return this.mapRoutesForSelect.filter(
          (route) => +route.id > +this.formData.pick_up.id
        );
      }

      return [];
    },
  },
  watch: {
    numberOfStops(value) {
      this.stops = [];
      if (value) {
        for (let i = 0; i < value; i++) {
          this.stops.push({ name: "" });
        }
      }
    },
  },
  methods: {
    processForm: function () {
      this.$v.formData.$touch();

      if (this.processing || this.$v.formData.$error) {
        return;
      }

      if (
        !this.formData.destination ||
        !this.formData.pick_up ||
        !this.formData.pickUpDate
      ) {
        this.$toast.error("Missing required fields");
        return;
      }

      this.processing = true;

      this.errorMessage = "";

      let data = {
        ...this.formData,
        pickup_address: this.formData.pick_up.label,
        vehicles: this.formData.passengers > 4 ? "Shuttle" : "Car",
        pickup_date: this.formData.pickUpDate,
        pickup_time: `${this.formData.pickUpHour}:${this.formData.pickUpMinute} ${this.formData.pickUpPeriod}`,
        dropoff_address: this.formData.destination.label,
        return_time: `${this.formData.returnHour}:${this.formData.returnMinute} ${this.formData.returnPeriod}`,
        return_address: this.formData.pick_up.label,
        pickup_geometry: `${this.formData.pick_up.latitude},${this.formData.pick_up.longitude}`,
        dropoff_geometry: `${this.formData.destination.latitude},${this.formData.destination.longitude}`,
        return_geometry: `${this.formData.pick_up.latitude},${this.formData.pick_up.longitude}`,
        stops: [...this.stops.map((stop) => stop.name)],
      };

      return axios
        .post("/charters", data)
        .then(() => {
          this.$eventTracker.logEvent(
            this.$eventTracker.trackingEvent.CHARTER_REQUEST,
            data
          );
          return this.$router.push("/dashboard/request-successful");
        })
        .catch((err) => {
          if (err.response && err.response.data.message) {
            this.errorMessage = err.response.data.message;
          } else {
            this.$toast.error(
              "An error occurred. Please pick another start date or try again later"
            );
          }

          return;
        })
        .finally(() => (this.processing = false));
    },
    getPosition: function (value) {
      {
        return (
          ["st", "nd", "rd"][
            (((((value < 0 ? -value : value) + 90) % 100) - 10) % 10) - 1
          ] || "th"
        );
      }
    },
  },
};
</script>

<style lang="scss">
.flatpickr-calendar {
  background-color: #ffffff !important;
  box-shadow: none !important;

  &.arrowTop:before,
  &.arrowTop:after {
    display: none;
  }
}

.flatpickr-weekday {
  color: #737d78 !important;
}

.flatpickr-day:not(.flatpickr-disabled) {
  font-weight: 500 !important;
}

.flatpickr-day {
  // color: theme('colors.widget-form-radio-label');
  font-size: 10px;

  &.prevMonthDay,
  &.flatpickr-disabled {
    color: #737d78 !important;
  }

  &.selected {
    background-color: #000000 !important;
    border: none;
  }
}

.flatpickr-monthDropdown-months,
.numInput.cur-year {
  color: #ffffff;
  font-size: 14px !important;
}

.flatpickr-current-month {
  display: flex !important;
  align-items: center;

  & > * + * {
    margin-left: 1rem !important;
  }
}

.vs__dropdown-toggle {
  border: 0;
  background-color: theme("colors.neutral.input");
  padding-top: 6px;
  padding-bottom: 6px;
}

.vs__dropdown-menu {
  background-color: theme("colors.neutral.input");
  color: #ffffff;
}

.vs__dropdown-option {
  color: theme("colors.widget-form-radio-label");
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;

  &--highlight {
    background: none;
  }
}

.vs__selected-options .vs__selected {
  color: #ffffff;
}

.vs--single .vs__selected {
  color: theme("colors.widget-form-radio-label");
}

.vs__selected {
  background: theme("colors.active");
  color: theme("colors.widget-form-radio-label");
  font-weight: 600;
  font-size: 0.875rem;
}

.vs__search::placeholder {
  color: #737d78;
  font-size: 0.875rem;
}

.input_style {
  padding-left: 10px;
}

.input_style::placeholder {
  font-size: 13px;
  opacity: 0.7;
}

.after_section {
  margin-left: 10px;
}

.option_ {
  font-size: 12.5px !important;
}

.return_time {
  margin-left: 20px;
}

.period_banner {
  margin-bottom: 10px;
}

.default {
  color: white;
}
</style>